import { Injectable } from '@angular/core';
import { StorageService } from '../../Common/services/storage.service';
import { UserLogin } from '../../Common/models/user.login';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserRole } from '../../Common/models/user.role';
import { promises } from 'dns';

@Injectable({
  providedIn: 'root'
})
export class UserRoleServiceService {

  roleOrder: { [key: string]: number } = {
    'SRE Admin': 1,
    'SRE Support': 2,
    'Customer Team': 3,
    'IT Admin': 4,
    'Agency User': 5
  };
  uInfo: UserLogin | null | undefined;
  role: UserRole | null | undefined;
  public disableAll: boolean= false;
  public userCategoryList: any[] = [];


  constructor(private storageService: StorageService) {
    this.uInfo = this.storageService.getItem<UserLogin>("UserInfo");
    this.getHighestRole();
  }

  async getCurrentRole(): Promise<UserRole> {
    return this.role!;
  }

  async getHighestRole(): Promise<any> {
    let roles: any[] = this.uInfo!.roles;

    if (roles.length === 0) {
      return '';
    }

    roles.sort((a, b) => this.roleOrder[a.roleName!] - this.roleOrder[b.roleName!]);

    this.role = roles[0];
    return this.role;
  }

  async getUserRoles(): Promise<any[]> {
    let roles: any[] = this.uInfo!.roles;
    return roles;
  }

  async canscreenEditAfterApprove(): Promise<boolean> {
    let result: boolean = false;
    return result;
  }

  async canscreenEditAfterReview(): Promise<boolean> {
    let result: boolean = false;

    if (this.role!.roleID == 2 || this.role!.roleID == 3) {
      result = true;
    }
    else {
      result = false;
    }

    return result;
  }

  async canAccessExecutionStart(): Promise<boolean> {
    let result: boolean = false;

    if (this.role!.roleID == 2 || this.role!.roleID == 3) {
      result = true;
    }
    else {
      result = false;
    }

    return result;
  }

  async canAccessExecutionEnd(): Promise<boolean> {
    let result: boolean = false;

    if (this.role!.roleID == 2 || this.role!.roleID == 3) {
      result = true;
    }
    else {
      result = false;
    }

    return result;
  }

  async canEdit(): Promise<boolean> {
    let result: boolean = false;

    if (this.role!.roleID == 2 || this.role!.roleID == 3) {
      result = true;
    }
    else {
      result = false;
    }

    return result;
  }

  async canApprove(): Promise<boolean> {
    let result: boolean = false;

    if (this.role!.roleID == 2) {
      result = true;
    }
    else {
      result = false;
    }

    return result;
  }

  async canRequestForReview(): Promise<boolean> {
    let result: boolean = false;

    if (this.role!.roleID == 2
      || this.role!.roleID == 3
      || this.role!.roleID == 4
    ) {
      result = true;
    }
    else {
      result = false;
    }

    return result;
  }
  disableField_bkp(catgId: number): boolean  {
    let encodedVal = localStorage.getItem('UserRoleInfo');
    if (encodedVal != null) {
      let userRoleInfo: UserLogin = JSON.parse(atob(encodedVal));
      this.userCategoryList = userRoleInfo.userCategory;
      let item= this.userCategoryList.find(x=>x.categoryID==catgId);
      this.disableAll= item == undefined;
      
    }
    return this.disableAll;

  }

  // Updated method to handle multiple category IDs
disableField(catgIds: number[]): boolean  {
  let encodedVal = localStorage.getItem('UserRoleInfo');
  if (encodedVal != null) {
    let userRoleInfo: UserLogin = JSON.parse(atob(encodedVal));
    this.userCategoryList = userRoleInfo.userCategory;

    // Check if any of the category IDs exist in userCategoryList
    let foundItem = catgIds.some(catgId => 
      this.userCategoryList.find(x => x.categoryID === catgId)
    );
    
    // Disable if no matching category IDs are found
    this.disableAll = !foundItem;
  }
  return this.disableAll;
}


}

